/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector, useDispatch } from "react-redux"
import { useEffect, useCallback, useContext, useState } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer, resetArrays } from "../../redux/MultiselectRows"
import ManageProviderTable from "./Components/Table"
import ManageProviderTopBar from "./Components/Topbar"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import { useGetProvidersQuery, useEditProviderMutation, useExportProvidersMutation } from "../../features/providerSlice"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import { handleAddFilterValues } from "../../redux/systemConfigSlice"
import ProviderSearch from "./Components/AdvancedSearch"
import { resetProviderSearch, setProSearchApplied } from "../../redux/providerSearchSlice"


export default function ManageProviders() {
    const { setToastmessage, setToastErrorMessage, isSideBar,isAdvancedSearchOpen } = useContext(GlobalContext);
    
    const [editProvider] = useEditProviderMutation()
    const [exportProviders] = useExportProvidersMutation()
    const [suggestions, setSuggestions] = useState("")
    const [limit, setLimit] = useState("15")
    const [skip, setSkip] = useState(true)
    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [loading, setLoading] = useState(false)
    const [isSortselected, setisSortSelected] = useState(false)
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [confirmationState, setConfirmationState] = useState({ isOpen: false, rowData: '', multirow: '', user_names: [] });
    const [textAreaMsg, setTextAreaMsg] = useState('')
    const [emptyField, setEmptyField] = useState(false);
    const auth = useSelector(state => state?.auth)
    const { userType } = auth
    const [filterValues, setFilterValues] = useState({});
    const providerSearch = useSelector(state => state.providerSearchData);
    const searchApplied = useSelector((state) => state.providerSearchData.prosearchApplied);


    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false });

    const { data, isFetching, isLoading, status } = useGetProvidersQuery(searchParams?.toString(), { skip: skip || location.search === '' })
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        // Only reset page_number to 1 if we're not explicitly setting page_number
        if (key !== 'page_number') {
            params.page_number = 1
        }
        // Ensure page_number is a valid number if being set
        if (key === 'page_number' && (isNaN(value) || value < 1)) {
            params[key] = 1
        } else if (key === 'search') { 
            params[key] = encodeURIComponent(value); 
        } else {
            params[key] = value
        }
        if (params.search === '') delete params.search
        setSearchParams({ ...params })
    }


    useEffect(() => {
        if (location.search === '') {
            setSkip(true)
        }
        if (location.state !== null && location.state !== '' && !Array.isArray(location.state)) {
            let params = {};
            if (location?.state?.search !== '') {
                params = {
                    'limit': location.state.limit,
                    'page_number': location.state.page_number,
                    'sort': 'created_at+desc',
                    'search': decodeURIComponent(location.state.search),
                    'search_mode':decodeURIComponent(location.state.search_mode)
                }
            } else {
                params = {
                    'limit': location.state.limit,
                    'page_number': location.state.page_number,
                    'sort': 'created_at+desc',
                }

            }
            // Set search params directly to preserve pagination state from navigation
            setSearchParams({ ...params })
        }
        else {
            // Only initialize default values if no search params exist
            if (!searchParams.get('limit')) {
                handleSearchParams('limit', '15')

            }
            if (!searchParams.get('page_number')) {
                handleSearchParams('page_number', '1')
            }
            if (!searchParams.get('sort')) {
                handleSearchParams('sort', `created_at+desc`)
            }
        }

        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')

    }, [location]);


    useEffect(() => {
        if (searchParams.size >= 3) {
            setSkip(false)
        }
        else {
            setSkip(true)
        }
    }, [searchParams])


    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }

    useEffect(() => {
        if (data !== undefined) {
            dispatch(limitReducer([data, searchParams.get("limit"), searchParams.get("page_number")]))
        }


    }, [data?.data]);

    const handleChange = (val) => {
        handleSearchParams('search', val)

    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );
    
    const handleCheckboxChange = (event, type) => {
        const { id, checked } = event.target;
        setFilterValues((prevState) => {
            const newState = { ...prevState };
            newState[type] = checked
                ? [...(newState[type] || []), id]
                : (newState[type] || []).filter((item) => item !== id);
            return newState;
        });
    };
    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
    
        if (type) {
            params.filter = "true";
    
            // Dispatch the filter values to Redux
            dispatch(handleAddFilterValues({
                status: filterValues.status,
                provider_credential: filterValues.provider_credential
            }));
    
            // Filter out empty values before updating searchParams
            const filteredStatus = filterValues.status && filterValues.status.length > 0
                ? filterValues.status.join(',')
                : null;
    
            const filteredPermissionAccess = filterValues.provider_credential && filterValues.provider_credential.length > 0
                ? filterValues.provider_credential.join(',')
                : null;
    
            if (filteredStatus) {
                params['status'] = filteredStatus;
            } else {
                delete params['status'];
            }
    
            if (filteredPermissionAccess) {
                params['provider_credential'] = filteredPermissionAccess;
            } else {
                delete params['provider_credential'];
            }
    
            setSearchParams({ ...params });
        } else {
            // Clear filterValues when type is false
            setFilterValues({
                status: [],
                provider_credential: [],
                // Add other properties if needed
            });
    
            // Remove filter-related keys from searchParams
            delete params['status'];
            delete params['provider_credential'];
            delete params['filter'];
    
            setSearchParams({ ...params });
        }
    };

    // apply search function
    const handleOnSubmit = (e) => {
        e.preventDefault();
    
        let searchString = '';
    
        
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `user_id` and `user_id_inverse` conditions
        if (providerSearch?.user_id && providerSearch?.user_id.trim()!=='') {
            const userIdPrefix = providerSearch.user_id_inverse ? 'ne:' : '';
            const formattedUserId = formatSearchValue(providerSearch.user_id);
            searchString += `user_id=${userIdPrefix}${encodeURIComponent(formattedUserId)};`;
        }

        // Check for `first_name` and `first_name_inverse` conditions
        if (providerSearch?.first_name && providerSearch?.first_name.trim()!=='') {
            const firstNamePrefix = providerSearch.first_name_inverse ? 'ne:' : '';
            const formattedFirstName = formatSearchValue(providerSearch.first_name);
            searchString += `first_name=${firstNamePrefix}${encodeURIComponent(formattedFirstName)};`;
        }

        // Check for `last_name` and `last_name_inverse` conditions
        if (providerSearch?.last_name && providerSearch?.last_name.trim()!=='') {
            const lastNamePrefix = providerSearch.last_name_inverse ? 'ne:' : '';
            const formattedLastName = formatSearchValue(providerSearch.last_name);
            searchString += `last_name=${lastNamePrefix}${encodeURIComponent(formattedLastName)};`;
        }

        // Check for `user_name` and `user_name_inverse` conditions
        if (providerSearch?.user_name || providerSearch.user_name_domain) {
            const userNamePrefix = providerSearch.user_name_inverse ? 'ne:' : '';
            const userName = formatSearchValue(providerSearch.user_name || '');
            const userNameDomain = formatSearchValue(providerSearch.user_name_domain || '');
            searchString += `user_name=${userNamePrefix}${encodeURIComponent(userName)}@${encodeURIComponent(userNameDomain)};`;
        }

        // Check for `email_address` and `email_address_inverse` conditions
        if (providerSearch?.email_address || providerSearch.email_address_domain) {
            const emailAddressPrefix = providerSearch.email_address_inverse ? 'ne:' : '';
            const emailAddress = formatSearchValue(providerSearch.email_address || '');
            const emailAddressDomain = formatSearchValue(providerSearch.email_address_domain || '');
            searchString += `email_address=${emailAddressPrefix}${encodeURIComponent(emailAddress)}@${encodeURIComponent(emailAddressDomain)};`;
        }

        // Check for `mobile_number` and `mobile_number_inverse` conditions
        if (providerSearch?.mobile_number_code || providerSearch.mobile_number) {
            const mobileNumPrefix = providerSearch.mobile_number_inverse ? 'ne:' : '';
            const mobileCountryCode = formatSearchValue(providerSearch.mobile_number_code || '');
            const mobileNumber = formatSearchValue(providerSearch.mobile_number || '');
            searchString += `mob_no_country_code-mobile_number=${mobileNumPrefix}${mobileCountryCode ? '+' : ''}${encodeURIComponent(mobileCountryCode)}-${encodeURIComponent(mobileNumber)};`;
        }

        // Check for `main_number` and `main_number_inverse` conditions
        if (providerSearch?.main_number_code || providerSearch.main_number) {
            const mainNumPrefix = providerSearch.main_number_inverse ? 'ne:' : '';
            const mainCountryCode = formatSearchValue(providerSearch.main_number_code || '');
            const mainNumber = formatSearchValue(providerSearch.main_number || '');
            searchString += `main_no_country_code-main_number=${mainNumPrefix}${mainCountryCode ? '+' : ''}${encodeURIComponent(mainCountryCode)}-${encodeURIComponent(mainNumber)};`;
        }
        // check for npi number
        if (providerSearch?.npi_number && providerSearch?.npi_number.trim()!=='') {
            const npinumberPrefix = providerSearch.npi_number_inverse ? 'ne:' : '';
            const formattednpinumber = formatSearchValue(providerSearch.npi_number);
            searchString += `npi_number=${npinumberPrefix}${encodeURIComponent(formattednpinumber)};`;
        }

        const { created_day, created_month, created_year } = providerSearch || {};
        // Check if only some of the fields are filled
        const isPartialDateFilled = (created_day && (!created_month || !created_year)) || (created_month && (!created_day || !created_year)) || (created_year && (!created_day || !created_month));

        if (isPartialDateFilled) {
            setEmptyField(true) 
            return;       
        } else if (created_day && created_month && created_year) {
            // Ensure date is in 'YYYY-MM-DD' format
            const dateStr = `${created_year}-${String(created_month).padStart(2, '0')}-${String(created_day).padStart(2, '0')}`;

            // Create a Date object at midnight (00:00:00)
            const date = new Date(`${dateStr}T00:00:00`);

            // Convert to epoch time in seconds
            const epochDate = Math.floor(date.getTime() / 1000);
            const createdDatePrefix = providerSearch.created_date_inverse ? 'ne:' : ''; 

            // Add epoch to search string
            searchString += `created_at=${createdDatePrefix}${epochDate};`;
        }        

        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
        
        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: providerSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            sort: currentParams.sort || 'created_at+desc', // Keep sort or set default
            limit: currentParams.limit || '15', // Keep limit or set default
        };
    
        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;
    
        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        dispatch(setProSearchApplied());
    };
    

    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) {
            dispatch(resetProviderSearch());
        }
    }, [dispatch, searchApplied]);
     

    
    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setEmptyField(false)
        setTextAreaMsg("")
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async (e) => {
        if ((confirmationState?.rowData !== undefined && confirmationState?.rowData !== "" && confirmationState?.rowData?.status === 'active' && textAreaMsg.trim() === '') || (confirmationState?.multirow === "deactive" && (textAreaMsg.trim() === ''))) {
            setToastErrorMessage('Please fill in the mandatory fields')
            setEmptyField(true)
            return;
        }
        try {
            let body = {}
            if (confirmationState?.rowData !== undefined && confirmationState?.rowData !== "") {
                {
                    confirmationState?.rowData?.status === 'inactive' ?
                        body = {
                            "user_name": [confirmationState?.rowData.user_name],
                            "status": confirmationState?.rowData?.status === "inactive" ? "active" : "inactive",
                            "note": textAreaMsg
                        } :
                        body = {
                            "user_name": [confirmationState?.rowData.user_name],
                            "status": confirmationState?.rowData?.status === "inactive" ? "active" : "inactive",
                            "note": textAreaMsg
                        }
                }
            }
            else {
                confirmationState?.multirow === "deactive" ?
                    body = {
                        "user_name": (selectedRows?.filter((user) => user.status !== 'inactive'))?.map((item) => item.name),
                        "status": confirmationState?.multirow === "deactive" ? "inactive" : "active",
                        "note": textAreaMsg
                    }
                    :
                    body = {
                        "user_name": (selectedRows?.filter((user) => user.status !== 'active'))?.map((item) => item.name),
                        "status": confirmationState?.multirow === "deactive" ? "inactive" : "active",
                        "note": textAreaMsg

                    }
            }
            setLoading(true)
            const activationRes = await editProvider({ body })
            setLoading(false)
            if (activationRes?.error) {
                setToastErrorMessage('Something went wrong. Please try again')
            } else {
                if (confirmationState?.multirow !== "" && confirmationState?.multirow !== undefined) {
                    setToastmessage(`Provider ${confirmationState?.multirow === "deactive" ? "deactivated" : "activated"} successfully`);
                }
                else {
                    setToastmessage(`Provider ${confirmationState?.rowData?.status === "inactive" ? "activated" : "deactivated"} successfully`);
                }
            }
            setTextAreaMsg('');
            dispatch(resetArrays())
            setConfirmationState({})

        } catch (error) {
            setConfirmationState({});
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }





    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Providers"} />
                <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                    <div className="px-6">
                        <ManageProviderTopBar
                            title={'List of Providers'}
                            path={'/manage-provider/add-provider'}
                            AddButton={true}
                            SearchInput={((data?.data?.length===0 &&searchParams.get("search")===null) ||data===undefined) ? false : true}
                            SearchPlaceholder={'Search for ID,Username etc'}
                            buttonName={"Add Provider"}
                            menuBar={(data !== undefined && data?.data?.length>0&&selectedRows?.length > 0) ? true : false}
                            ApplyFilter={true}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['ID', 'Username', 'First Name', 'Last Name','Credentials','Status', 'Email Address', 'Mobile Number', 'Main Number','NPI Number','Created Date']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportUsers={exportProviders}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            handleCheckboxChange={handleCheckboxChange}
                            handleApplyFilter={handleApplyFilter}
                            searchProvider={true}

                        /> 
                    </div>
                    {((isFetching && status !== "fulfilled" && status !== "rejected" && !isSortselected) || (isLoading) || (data === undefined && status !== "fulfilled" && status !== "rejected")) ? <CustomOverLay Active text="Loading Provider list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? 'opened_sidebar_overlay' : 'overlay-list'}`} /> : (data !== undefined && data?.data?.length > 0) ? <>
                        <div className="px-6">

                            <ManageProviderTable
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}

                            />
                        </div>
                        {data?.total_count >= 15 && <div className="w-full px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />
                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </> : <>
                        {(data?.total_count === 0 &&suggestions?.trim()!=="") || (data?.success_status === "false") ||(searchParams.get('status')!==null||searchParams.get('start_date')!==null||searchParams.get('end_date')!==null||searchParams.get('organization_id')!==null||searchParams.get('subdivision_ids')!==null) ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                            :
                            data?.total_count === 0 && !searchParams.get("search") ? <Emptyscreen
                                title={"Manage Providers"}
                                FirstPTag={"No Providers added yet."}
                                SecondePTag={"Start managing by clicking Add Provider"}
                            /> : status === "rejected" && <SearchEmptyScreen text={"No data found"} />
                        }
                    </>}
                </div>
                {confirmationState.isOpen &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyField}
                                setEmptyField={setEmptyField}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={handleConformationClick}
                                tittle= {confirmationState?.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==="active"?'Activate':'Deactivate'}
                                message = {confirmationState.rowData!==""?`Are you sure you want ${confirmationState?.rowData?.status==="inactive"? 'activate' : 'deactivate'} the provider?`:
                                    `Are you sure you want to ${confirmationState.multirow==='active'?'activate':'deactivate'} the following providers?`}
                                textMessage = {confirmationState.rowData!==""?confirmationState?.rowData?.status === 'inactive' ? true : false:confirmationState.multirow==="active"?true:false}
                                buttonName = {confirmationState.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==='active'?'Activate':'Deactivate'}
                                userList={confirmationState?.multirow===''?'':confirmationState?.multirow==="deactive"?(selectedRows?.filter((user)=>user.status!=='inactive'))?.map((item)=>item.name):(selectedRows?.filter((user)=>user.status!=='active'))?.map((item)=>item.name)}
                                loadingActivation={loading}
                            />
                        }
                    />
                }
            </div>
            {isAdvancedSearchOpen&&searchParams?.get('limit')&&!searchParams?.get('target_user_name') &&
                <ProviderSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={emptyField}
                    setEmptyField={setEmptyField}
                />
            }
        </>

    )
}